import { AiOutlineClose } from "react-icons/ai"
import { Heading, TypographyType, TypographyColor } from ".."
import geoSerachInfo from '../../utils/images/GeoSearchInfo.svg';
import React from "react";
import styles from "./Toast.module.css";

interface MapToastProps {
    onClose: () => void;
    message: string;
}

export const MapToast: React.FC<MapToastProps> = ({ onClose, message }) => {

    return (
        <div className={`${styles.map_toast} d-flex justify-content-center align-items-start text-start rounded padding-3`}>
            <div className="d-flex justify-content-center align-items-center text-start gap-2 h-100">
                <img src={geoSerachInfo} alt="" className={`text-center ${styles.map_toast_img}`} />
                <Heading
                    title={message}
                    type={TypographyType.h6}
                    colour={TypographyColor.secondary}
                    classname="h-100 d-flex align-items-center"
                />
            </div>
            <AiOutlineClose
                size={14}
                className="text-start cursor-pointer"
                onClick={onClose}
            />
        </div>
    )
}